import { render, staticRenderFns } from "./jx1.vue?vue&type=template&id=2316e000&"
import script from "./jx1.vue?vue&type=script&lang=js&"
export * from "./jx1.vue?vue&type=script&lang=js&"
import style0 from "./jx1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports